import {stopLoadingSpinner} from "../../../components/csf-ufc-pivotal/includes/utils";
import PivotalApiEnvironments from "./PivotalApiEnvironments";

export class PivotalApiBase {

  // check the API documentation, Annexe 3 for all operators and add here if needed
  static get PIVOTAL_CONDITION_OP_EQUAL() {
    return 5;
  }

  static get PIVOTAL_CONDITION_OP_CONTAINS() {
    return 7;
  }

  static get PIVOTAL_ENV_SPLIT_BROKER() {
    return PivotalApiEnvironments.getBrokerSuffix();
  }

  static get PIVOTAL_ENV_SPLIT_FOURNISSEUR() {
    return PivotalApiEnvironments.getFournisseurSuffix();
  }

  static get PIVOTAL_ENV_SPLIT_MEMBRE() {
    return PivotalApiEnvironments.getMembreSuffix();
  }

  constructor(baseUrl, apiEnv, apiToken) {
    this.baseUrl = baseUrl;
    this.apiEnv = apiEnv;
    this.apiToken = apiToken;
  }

  /*
  * Generic method to call api: call from class extending from PivotalBaseApi
  * */
  async _fetchPostRequest(url, requestData, envSplit) {
    const requestMetadata = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'pivotalEnvironmentName': (this.apiEnv + envSplit),
        'Authorization': `Bearer ${this.apiToken}`
      },
      body: JSON.stringify(requestData)
    };
    const response = await fetch(`${this.baseUrl}${url}`, requestMetadata);

    if (response.status === 401) {
      fetch('/csf-api-fournisseur/access-denied-redirect-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
      }).then(response => response.json())
        .then(data => {
          window.location.href = data?.redirect_url || '/';
        })
      throw new Error('Unautorized 401 response status');
    }

    return response.json();
  }

  /*
  * Generic method to call api: call from class extending from PivotalBaseApi
  * */
  async _fetchDeleteRequest(url, requestData, envSplit) {
    const requestMetadata = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'pivotalEnvironmentName': (this.apiEnv + envSplit),
        'Authorization': `Bearer ${this.apiToken}`
      },
      body: JSON.stringify(requestData)
    };

    const response = await fetch(`${this.baseUrl}${url}`, requestMetadata);
    return response.json();
  }

  /*
  * Generic method to call api: call from class extending from PivotalBaseApi
  * */
  async _fetchPostLoginRequest(url, requestData, envSplit) {
    const requestMetadata = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'pivotalEnvironmentName': (this.apiEnv + envSplit),
      },
      body: JSON.stringify(requestData)
    };

    const response = await fetch(`${this.baseUrl}${url}`, requestMetadata);
    return response.json();
  }

  /*
  * Generic method to call api: call from class extending from PivotalBaseApi
  * */
  async _fetchAttachmentsRequest(url, requestData, envSplit) {
    const requestMetadata = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'pivotalEnvironmentName': (this.apiEnv + envSplit),
        'Authorization': `Bearer ${this.apiToken}`
      },
      body: JSON.stringify(requestData)
    };

    const response = await fetch(`${this.baseUrl}${url}`, requestMetadata);
    return response.blob();
  }

  /*
  * Generic method to call api: call from class extending from PivotalBaseApi
  * */
  async _uploadAttachmentsRequest(url, requestData, envSplit) {
    const requestMetadata = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'pivotalEnvironmentName': (this.apiEnv + envSplit),
        'Authorization': `Bearer ${this.apiToken}`
      },
      body: JSON.stringify(requestData)
    };

    const response = await fetch(`${this.baseUrl}${url}`, requestMetadata);
    return response.json();
  }

  /*
  * Generic method to call api: call from class extending from PivotalBaseApi
  * */
  async _fetchPutRequest(url, requestData, envSplit) {
    const requestMetadata = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'pivotalEnvironmentName': (this.apiEnv + envSplit),
        'Authorization': `Bearer ${this.apiToken}`
      },
      body: JSON.stringify(requestData)
    };
    const response = await fetch(`${this.baseUrl}${url}`, requestMetadata);
    return response.json();
  }

}
